import React from "react";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {CookiesKey, useCookies} from "@/app/utils/cookies";
import {route} from "@/app/routes/AppRoutes";
import AppBar from "@/app/features/app_bar/widget";

const ProtectedRoute: React.FC = () => {
  const {getCookie} = useCookies();
  const token = getCookie(CookiesKey.token);
  const location = useLocation();

  if (!token) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`${route.signup}?redirect=${redirect}`} replace/>;
  }

  // Global onboarding enforcement: if user profile is not yet created (profile === null or id == null),
  // redirect to onboarding from any protected route.
  const rawUser = getCookie(CookiesKey.user);
  if (rawUser) {
    try {
      const user = JSON.parse(rawUser) as { id?: number | null; profile?: any | null } | null;
      const needsOnboarding = !!user && (user.id == null || user.profile === null);
      if (needsOnboarding && location.pathname !== route.onboarding) {
        return <Navigate to={route.onboarding} replace/>;
      }
    } catch {
      // ignore malformed cookie and proceed normally
    }
  }

  return <>
    <AppBar/>
    <Outlet/>
  </>;
};

export default ProtectedRoute;
